// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var List = require("rescript/lib/js/list.js");
var $$Array = require("rescript/lib/js/array.js");
var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Belt_List = require("rescript/lib/js/belt_List.js");
var Js_promise = require("rescript/lib/js/js_promise.js");
var Pervasives = require("rescript/lib/js/pervasives.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Json_decode = require("@glennsl/bs-json/src/Json_decode.res.js");
var JsxRuntime = require("react/jsx-runtime");
var Http$ReactHooksTemplate = require("../common/http.res.js");
var Feature$ReactHooksTemplate = require("./feature.res.js");

function LlmFeatureTester(props) {
  var features = props.features;
  var match = React.useState(function (param) {
        
      });
  var setSelectedFeature = match[1];
  var selectedFeature = match[0];
  var match$1 = React.useState(function (param) {
        return "";
      });
  var setInputText = match$1[1];
  var inputText = match$1[0];
  var match$2 = React.useState(function (param) {
        
      });
  var setResult = match$2[1];
  var result = match$2[0];
  var match$3 = React.useState(function (param) {
        return false;
      });
  var setTesting = match$3[1];
  var testing = match$3[0];
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx("h2", {
                      children: "🔍 Test AI Feature",
                      className: "text-xl font-semibold mb-4 text-gray-800"
                    }),
                JsxRuntime.jsx("div", {
                      children: JsxRuntime.jsxs("select", {
                            children: [
                              JsxRuntime.jsx("option", {
                                    children: "-- Select a Feature --",
                                    value: ""
                                  }),
                              $$Array.of_list(List.map((function (f) {
                                          var fid = Feature$ReactHooksTemplate.id(f);
                                          if (fid !== undefined) {
                                            return JsxRuntime.jsx("option", {
                                                        children: Feature$ReactHooksTemplate.name(f),
                                                        value: String(fid)
                                                      });
                                          } else {
                                            return null;
                                          }
                                        }), features))
                            ],
                            className: "flex-1 border rounded-lg p-2 focus:ring-2 focus:ring-indigo-500",
                            value: selectedFeature !== undefined ? String(Belt_Option.getExn(Feature$ReactHooksTemplate.id(selectedFeature))) : "",
                            onChange: (function (e) {
                                var id = Pervasives.int_of_string_opt(e.target.value);
                                if (id !== undefined) {
                                  return Curry._1(setSelectedFeature, (function (param) {
                                                return Belt_List.getBy(features, (function (f) {
                                                              var fid = Feature$ReactHooksTemplate.id(f);
                                                              if (fid !== undefined) {
                                                                return fid === id;
                                                              } else {
                                                                return false;
                                                              }
                                                            }));
                                              }));
                                } else {
                                  return Curry._1(setSelectedFeature, (function (param) {
                                                
                                              }));
                                }
                              })
                          }),
                      className: "flex gap-4 mb-4"
                    }),
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("input", {
                              className: "flex-1 border rounded-lg px-3 py-2 text-sm focus:ring-2 focus:ring-indigo-500",
                              placeholder: "Enter text to test the selected feature...",
                              value: inputText,
                              onChange: (function (e) {
                                  Curry._1(setInputText, (function (param) {
                                          return e.target.value;
                                        }));
                                })
                            }),
                        JsxRuntime.jsx("button", {
                              children: testing ? "Testing..." : "Test",
                              className: "px-4 py-2 rounded-lg text-white " + (
                                testing ? "bg-gray-400 cursor-not-allowed" : "bg-green-600 hover:bg-green-700 " + (
                                    inputText === "" ? "hidden" : "block"
                                  )
                              ),
                              disabled: testing || inputText === "",
                              onClick: (function (param) {
                                  if (selectedFeature === undefined) {
                                    return Curry._1(setResult, (function (param) {
                                                  return "Please select a feature first";
                                                }));
                                  }
                                  var fid = Feature$ReactHooksTemplate.id(selectedFeature);
                                  if (fid === undefined) {
                                    return Curry._1(setResult, (function (param) {
                                                  return "Invalid feature ID";
                                                }));
                                  }
                                  Curry._1(setTesting, (function (param) {
                                          return true;
                                        }));
                                  Curry._1(setResult, (function (param) {
                                          
                                        }));
                                  var body = {};
                                  body["feature_id"] = fid;
                                  body["text"] = inputText;
                                  Js_promise.$$catch((function (param) {
                                          Curry._1(setResult, (function (param) {
                                                  return "Network error while testing AI";
                                                }));
                                          Curry._1(setTesting, (function (param) {
                                                  return false;
                                                }));
                                          return Promise.resolve();
                                        }), Js_promise.then_((function (res) {
                                              var status = Json_decode.field("status", (function (param) {
                                                      return Json_decode.withDefault("failed", Json_decode.string, param);
                                                    }), res);
                                              if (status === "success") {
                                                var data = Json_decode.optional((function (param) {
                                                        return Json_decode.field("result", Json_decode.string, param);
                                                      }), res);
                                                Curry._1(setResult, (function (param) {
                                                        return Belt_Option.getWithDefault(data, "No response received");
                                                      }));
                                              } else {
                                                var msg = Json_decode.optional((function (param) {
                                                        return Json_decode.field("message", Json_decode.string, param);
                                                      }), res);
                                                Curry._1(setResult, (function (param) {
                                                        return Belt_Option.getWithDefault(msg, "Failed to analyze text");
                                                      }));
                                              }
                                              Curry._1(setTesting, (function (param) {
                                                      return false;
                                                    }));
                                              return Promise.resolve();
                                            }), Http$ReactHooksTemplate.fetchPostJSON("/api/v1/app_features/test_llm", body)));
                                })
                            }),
                        JsxRuntime.jsx("button", {
                              children: "clear",
                              className: "px-4 py-2 rounded-lg text-white bg-yellow-500 " + (
                                inputText === "" ? "hidden" : "block"
                              ),
                              disabled: testing || inputText === "",
                              onClick: (function (param) {
                                  Curry._1(setInputText, (function (param) {
                                          return "";
                                        }));
                                  Curry._1(setSelectedFeature, (function (param) {
                                          
                                        }));
                                  Curry._1(setResult, (function (param) {
                                          
                                        }));
                                })
                            })
                      ],
                      className: "flex gap-3 mb-4"
                    }),
                result !== undefined ? JsxRuntime.jsx("div", {
                        children: result,
                        className: "mt-3 text-sm text-gray-800 bg-gray-50 border rounded-lg p-3"
                      }) : null
              ],
              className: "bg-white rounded-xl shadow-lg border border-gray-200 p-6 hover:shadow-xl transition-shadow duration-300"
            });
}

var make = LlmFeatureTester;

exports.make = make;
/* react Not a pure module */
